import { DEFAULT_SITE } from './siteDefaults';

function strPrefer(a, b, fallback = '') {
  if (typeof a === 'string' && a.trim()) return a.trim();
  if (typeof b === 'string' && b.trim()) return b.trim();
  return typeof fallback === 'string' ? fallback : '';
}

function resolveStory(site) {
  const d =
    DEFAULT_SITE.farmer?.story && typeof DEFAULT_SITE.farmer.story === 'object'
      ? DEFAULT_SITE.farmer.story
      : {};
  const s = site?.farmer?.story && typeof site.farmer.story === 'object' ? site.farmer.story : {};
  const bulletsFromApi = Array.isArray(s.bullets)
    ? s.bullets.map((b) => (typeof b === 'string' ? b.trim() : '')).filter(Boolean)
    : [];
  const bulletsFromDefault = Array.isArray(d.bullets)
    ? d.bullets.map((b) => (typeof b === 'string' ? b.trim() : '')).filter(Boolean)
    : [];
  const bullets = bulletsFromApi.length ? bulletsFromApi : bulletsFromDefault;

  return {
    badge: strPrefer(s.badge, d.badge, 'In the field'),
    eyebrow: strPrefer(s.eyebrow, d.eyebrow, 'Rooted in the field'),
    title: strPrefer(s.title, d.title, 'When growers thrive, our work has meaning'),
    body: strPrefer(
      s.body,
      d.body,
      'Rafid Seeds exists because millions of families depend on what happens between soil and harvest. Our farmer story is not a slogan—it is the daily rhythm of trials in real plots, training in local languages, and agronomists who answer the phone when weather shifts overnight. We listen first: which variety struggled in your block, what moisture looked like at flowering, whether the label matched what you saw in the bag. That feedback loops straight into sourcing, processing, and the next season’s recommendations.'
    ),
    image: strPrefer(s.image, d.image, ''),
    imageAlt: strPrefer(s.imageAlt, d.imageAlt, 'Farmers and field staff walking through crops at sunrise'),
    caption: strPrefer(
      s.caption,
      d.caption,
      'Training, trials, and honest advice—season after season.'
    ),
    bullets,
  };
}

function resolveClosing(site) {
  const d =
    DEFAULT_SITE.farmer?.closing && typeof DEFAULT_SITE.farmer.closing === 'object'
      ? DEFAULT_SITE.farmer.closing
      : {};
  const c = site?.farmer?.closing && typeof site.farmer.closing === 'object' ? site.farmer.closing : {};
  return {
    eyebrow: strPrefer(c.eyebrow, d.eyebrow, 'How we show up'),
    title: strPrefer(c.title, d.title, 'Partnership, not just supply'),
    body: strPrefer(
      c.body,
      d.body,
      'We measure success in repeat plantings, stable yields, and growers who recommend us to a neighbor. That takes transparent labeling, fair channel practices, and technical support that respects your time. Whether you farm two bighas or two hundred, you deserve seed handled with care—and people who stay accountable after the sale.'
    ),
  };
}

/** Public Farmer story page: merge CMS `site.farmer` with packaged defaults. */
export function resolveFarmer(site) {
  const d = DEFAULT_SITE.farmer && typeof DEFAULT_SITE.farmer === 'object' ? DEFAULT_SITE.farmer : {};
  const f = site?.farmer && typeof site.farmer === 'object' ? site.farmer : {};

  return {
    pageHeroImage: strPrefer(f.pageHeroImage, d.pageHeroImage, ''),
    heroTitle: strPrefer(f.heroTitle, d.heroTitle, 'Farmer story'),
    heroBreadcrumbHome: strPrefer(f.heroBreadcrumbHome, d.heroBreadcrumbHome, 'Home'),
    heroBreadcrumbCurrent: strPrefer(f.heroBreadcrumbCurrent, d.heroBreadcrumbCurrent, 'Farmer story'),
    story: resolveStory(site),
    closing: resolveClosing(site),
  };
}
